import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "check" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tirscript-checkbox", { disabled: _ctx.innerDisabled, checked: _ctx.innerChecked }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.innerChecked)
        ? _renderSlot(_ctx.$slots, "checked", { key: 0 }, () => [
            _hoisted_2
          ])
        : _renderSlot(_ctx.$slots, "unchecked", { key: 1 })
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}